<template>
    <v-switch
        v-bind:input-value="value"
        :class="{ 'switch-invisible': markedForDeletion }"
        :aria-label="switchAriaLabel"
        :disabled="switchDisabled"
        dense hide-details
        :inset="inset"
        :flat="flat"
        style="margin-top: 0; padding-top: 0;"
        v-on:change="$emit('input', $event)"
    />
</template>

<script>
export default {
    name: 'publish-approve-switch',
    props: {
        value: {
            type: Boolean | undefined,
            required: true
        },
        markedForDeletion: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        approvePrivilege: {
            type: String,
            default: null
        },
        inset: {
            type: Boolean,
            default: true
        },
        flat: {
            type: Boolean,
            default: false
        }
    },
    emits: ['input'],
    computed: {
        switchDisabled() {
            return this.readonly || !this.approvePrivilege || this.markedForDeletion;
        },
        switchAriaLabel() {
            return this.modelValue ? Lang.langGet('Disapprove') : Lang.langGet('Approved');
        }
    }
};
</script>
